
import React from 'react';
import { Modal } from 'react-bootstrap'
import EditarDatosBancarios from './EditarDatosBancarios'

class EditarDatosBancariosModal extends React.Component {
    render() {
        return (
            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Datos Bancarios                    
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <EditarDatosBancarios userToken={this.props.userToken} id={this.props.id} />
                </Modal.Body>
            </Modal>
        );
    }
}

export default EditarDatosBancariosModal;